'use client'
import { FlightSearchPageResponse } from '@/src/types/seoSrpResult'
import dynamic from 'next/dynamic'

const FlightSchedulePageDesktopContainer = dynamic(
    () =>
        import(/* webpackChunkName: "FlightSchedulePageDesktopContainer" */ '@/src/containers/desktop/flightSchedule'),
    {
        ssr: true
    }
)

const FlightSchedulePageMobileContainer = dynamic(
    () => import(/* webpackChunkName: "FlightSchedulePageMobileContainer" */ '@/src/containers/mobile/flightSchedule/'),
    {
        ssr: true
    }
)

interface FlightScheduleRootLoaderProps {
    isMobile: boolean
    srpData: FlightSearchPageResponse
}

const FlightScheduleRootLoader = ({ isMobile, domainCountry }: { isMobile: boolean; domainCountry: string }) => {
    return isMobile ? <FlightSchedulePageMobileContainer /> : <FlightSchedulePageDesktopContainer domainCountry={domainCountry} />
}

export default FlightScheduleRootLoader
